module.exports = __webpack_public_path__ + "static/media/calendar.16d04d23.svg";